<template lang="pug">
  div.tendency-chart
    module-title(title="危机趋势图")
    event-vein-line
</template>

<script>
import ModuleTitle from '../EventCenter/ModuleTitle'
import EventVeinLine from './EventVeinLine'
export default {
  name: 'TendencyChart',
  components: {
    ModuleTitle,
    EventVeinLine
  }
}
</script>

<style lang="scss" scoped>
  .tendency-chart{
    height: 600px;
    background-color: #ffffff;
    border-radius: 4px;
    margin-top: 20px;
    padding: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/EventTendency/TendencyChart.vue